import { convertRhinoAssetTypeToMediaType, isSingleRecordingAsset, RecordingAsset } from '@kaltura-ott/tvpil-shared';

import routes from 'routesPaths';
import { resolvePathToDetailsPage } from 'utils';

type GetRecordingCardLinkParams = {
  recording: RecordingAsset;
  isProgramLive: boolean;
  collectionType: string;
  isFuture: boolean;
};

export function getRecordingIconType(recording: RecordingAsset): 'single' | 'series' {
  return isStandaloneRecordingAsset(recording) ? 'single' : 'series';
}

export function isStandaloneRecordingAsset(recording: RecordingAsset): boolean {
  return isSingleRecordingAsset(recording) && (!recording?.totalEpisodesCount || hasSingleEpisode(recording));
}

function hasSingleEpisode(recording: RecordingAsset): boolean {
  return recording?.totalEpisodesCount === 1;
}

export function isPlayableRecording(recording: RecordingAsset): boolean {
  return recording.viewableUntilDate !== 0;
}

export function getRecordingLink({ recording, isProgramLive, collectionType, isFuture }: GetRecordingCardLinkParams) {
  const mediaTypeParam = convertRhinoAssetTypeToMediaType(recording.type).toLowerCase();

  const isStandaloneRecording = isStandaloneRecordingAsset(recording);

  if (isPlayableRecording(recording)) {
    if (isProgramLive) {
      return routes.live.link(recording.channelId, mediaTypeParam);
    }
    if (isStandaloneRecording) {
      return routes.program.link(recording.id, mediaTypeParam);
    }
  }

  return resolvePathToDetailsPage({
    id: recording.id,
    subtype: collectionType,
    mediaTypeParam,
    seriesId: recording.seriesId,
    isAggregatedSeriesRecord: !isStandaloneRecording,
    isProgramRecord: true,
    isFuture
  });
}
